/*
 * Copyright (c) 2025. Bolmate B.V.
 */
import React, {useMemo} from 'react';
import {NotificationType} from "../../../util/enums";
import Notification from "../../../models/notificationModel";
import {AwesomeIcon} from "@dvrd/dvr-controls";
import {NotificationProps, NotificationTypeProps} from "../notificationsPage";
import useDefaultNotification from "../useDefaultNotification";
import NotificationEmail from "../notificationComponents/notificationEmail";
import NotificationProducts from "../notificationComponents/notificationProducts";
import NotificationActions from "../notificationComponents/notificationActions";
import NotificationIntervalComp from "../notificationComponents/notificationInterval";

function OrderNotification(props: NotificationProps) {
    const {
        notification, loading, onDeleteNotification, onSendTestNotification, canEdit, canDelete,
        onChangeNotification, onReplaceNotification
    } = props;
    const [onChangeEmailAddresses] = useDefaultNotification({...props});

    function renderTitle() {
        return (
            <div className='notification-title beta'>
                <AwesomeIcon name='truck-fast' className='type-icon'/> Order notificatie
            </div>
        );
    }

    return (
        <div className='notification-config'>
            {renderTitle()}
            <div className='notification'>
                <NotificationProducts onSuccess={onReplaceNotification} notification={notification}
                                      disabled={loading || !canEdit} text='Bij nieuwe orders voor'/>
                <NotificationEmail onChangeEmailAddresses={onChangeEmailAddresses}
                                   emailAddresses={notification.emailAddresses}
                                   disabled={loading || !canEdit}/>
                <NotificationIntervalComp onChangeNotification={onChangeNotification}
                                          disabled={loading || !canEdit} notification={notification}
                                          withRealtime/>
            </div>
            <NotificationActions onDeleteNotification={onDeleteNotification}
                                 onSendTestNotification={onSendTestNotification} notification={notification}
                                 canDelete={canDelete} disabled={false}/>
        </div>
    )
}

export default function OrderNotifications(props: NotificationTypeProps) {
    const {notifications} = props;
    const orderNotifications = useMemo(() => {
        return notifications.filter(
            (notification: Notification) => notification.notificationType === NotificationType.ORDER);
    }, [notifications]);
    if (!orderNotifications.length) return null;


    function renderNotification(notification: Notification, index: number) {
        return <OrderNotification key={index} notification={notification} disabled={false} {...props}/>;
    }

    return (
        <div className='notification-type order-notifications'>
            <div className='notifications'>
                {orderNotifications.map(renderNotification)}
            </div>
        </div>
    )
}